import { NavLink } from "react-router-dom";
import { Users, Library, School, AudioLines } from "lucide-react";

const TABS = [
  { to: "/admin", label: "المسجلون", icon: Users, id: "users" },
  { to: "/admin/books", label: "الكتب", icon: Library, id: "books" },
  { to: "/admin/classes", label: "الصفوف", icon: School, id: "classes" },
  { to: "/admin/voices", label: "الأصوات", icon: AudioLines, id: "voices" },
];

export const AdminTabs = () => (
  <div className="flex gap-2 mb-8 border-b border-[#E5DCCB] overflow-x-auto" data-testid="admin-tabs">
    {TABS.map((t) => (
      <NavLink key={t.to} to={t.to} end data-testid={`admin-tab-${t.id}`}
        className={({ isActive }) => `shrink-0 inline-flex items-center gap-2 px-5 py-3 font-semibold -mb-px border-b-[3px] transition-colors ${isActive ? "border-[#8B3A2B] text-[#1C1917]" : "border-transparent text-stone-600 hover:text-[#1C1917]"}`}>
        <t.icon className="w-4 h-4" /> {t.label}
      </NavLink>
    ))}
  </div>
);
